let openedModal;

export const showModal = (target, cb) => {
  // target - dom элемент или css селектор модального окна, в ином случае
  // селектор возьмется из this (data-modal или href)
  let targetElem;
  if (typeof target === 'string') {
    targetElem = document.querySelector(target);
  }
  else if ((target instanceof Element) && target.getAttribute('data-modal')) {
    targetElem = document.querySelector(target.getAttribute('data-modal'));
  }
  else if ((target instanceof Element) && target.getAttribute('href')) {
    targetElem = document.querySelector(target.getAttribute('href'));
  }
  else if (target instanceof Element) {
    let parentLink = null;
    if (target.closest('[data-modal]')) {
      parentLink = target.closest('[data-modal]').getAttribute('data-modal');
    }
    else if (target.closest('[href]')) {
      parentLink = target.closest('[href]').getAttribute('href');
    }
    targetElem = parentLink ? document.querySelector(parentLink) : target;
  }
  else if (this && this.getAttribute('data-modal')) {
    targetElem = document.querySelector(this.getAttribute('data-modal'));
  }
  else if (this && this.getAttribute('href')) {
    targetElem = document.querySelector(this.getAttribute('href'));
  }
  else {
    return false;
  }
  targetElem.classList.add('modal_shown');
  document.body.classList.add('noscroll');

  const inputs = targetElem.querySelectorAll('.form__item input');
  for (let i = 0; i < inputs.length; i += 1) {
    const inp = inputs[i];
    if (!inp.getAttribute('readonly')) {
      window.setTimeout(function () {
        inp.focus();
      }, 50);
      break;
    }
  }

  if (cb) {
    cb();
  }

  if (openedModal) {
    openedModal.classList.remove('modal_shown');
  }
  openedModal = targetElem;


  targetElem.addEventListener('click', (e) => {
    if (e.target === targetElem) {
      return closeModals();
    }
  });
  window.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      return closeModals();
    }
  });
  const closeBtns = document.querySelectorAll('.modal-close');
  [...closeBtns].map((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      return closeModals();
    })
  })
};

export const closeModals = () => {
  const activeModal = document.querySelector('.modal_shown');
  if (activeModal) {
    activeModal.classList.remove('modal_shown');
    openedModal = '';
    document.body.classList.remove('noscroll');
    return true;
  }
  return false;
};